export default __webpack_public_path__ + "static/media/the-food-fight-podcast-eit-food.bcc21c8c.png";